export default {
  auth: () => import("/vercel/path0/layouts/auth.vue").then(m => m.default || m),
  call: () => import("/vercel/path0/layouts/call.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  transport: () => import("/vercel/path0/layouts/transport.vue").then(m => m.default || m)
}